<template>
  <div class="contact-category-list">
    <div class="search-bar-component">
      <b-row class="mb-1 mb-md-2">
        <b-col cols="12">
          <b-input-group size="lg" class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input v-model="searchQuery" placeholder="Sök kontakt..." />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <b-row v-for="(accessGroup, index) in accessGroups" :key="index">
      <b-col cols="12">
        <div
          v-if="
            filteredContacts.find((ct) =>
              ct.access_groups.find((ctac) => ctac.id === accessGroup.id)
            )
          "
          :class="'contact-group contact-group-' + accessGroup.id"
        >
          <b-button
            v-b-toggle="'collapse-' + accessGroup.id"
            variant="flat"
            class="border-bottom mb-1"
            block
            ><h4 class="mb-0">
              {{ accessGroup.title }}
              <span class="text-primary"
                ><i class="fas fa-caret-down"></i
              ></span></h4
          ></b-button>
          <b-collapse visible :id="'collapse-' + accessGroup.id">
            <div class="ce-contact-list">
              <div v-for="contact in filteredContacts" :key="contact.id">
                <template
                  v-if="
                    contact.access_groups.find((a) => a.id == accessGroup.id)
                  "
                >
                  <b-card no-body class="ce-contact-list-item">
                    <div class="card-body">
                      <b-row>
                        <b-col cols="12" md="6" lg="8" class="ce-contact-info">
                          <div class="ce-contact-avatar">
                            <b-avatar
                              v-if="contact.has_user"
                              size="4rem"
                              :src="
                                contact.avatar
                                  ? contactImageUrls[contact.id]
                                  : ''
                              "
                              badge
                              badge-variant="success"
                              badge-offset="-2px"
                            />
                            <b-avatar
                              v-else
                              size="4rem"
                              :src="
                                contact.avatar
                                  ? contactImageUrls[contact.id]
                                  : ''
                              "
                            />
                          </div>
                          <div class="ce-contact-description">
                            <div class="d-flex">
                              <h6 class="mb-0">
                                {{ contact.first_name }} {{ contact.last_name }}
                              </h6>
                              <div
                                class="tag-style ml-2"
                                v-if="
                                  contact.access_groups.find(
                                    (a) => a.title == 'Viktig person'
                                  )
                                "
                              >
                                <i :class="'fas fa-users'"></i>
                                Viktig person
                              </div>
                            </div>
                            <p>
                              <small
                                ><span v-if="contact.title">{{
                                  contact.title
                                }}</span
                                ><span
                                  v-if="contact.organisation && contact.title"
                                  >, </span
                                ><span v-if="contact.organisation">{{
                                  contact.organisation
                                }}</span></small
                              >
                            </p>
                          </div>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                          class="ce-contact-actions mt-1 mt-sm-0"
                        >
                          <span v-if="contact.phone" class="mr-1">
                            <a
                              :href="'tel:' + contact.phone"
                              class="btn btn-outline-primary btn-sm"
                              ><i class="fas fa-phone"></i
                            ></a>
                          </span>
                          <span v-if="contact.mobile" class="mr-1">
                            <a
                              :href="'tel:' + contact.mobile"
                              class="btn btn-outline-primary btn-sm"
                              ><i class="fas fa-mobile"></i
                            ></a>
                          </span>
                          <span v-if="contact.mobile" class="mr-1">
                            <a
                              :href="'sms:' + contact.mobile"
                              class="btn btn-outline-primary btn-sm"
                              ><i class="fas fa-comment-dots"></i
                            ></a>
                          </span>
                          <b-button
                            @click="goToContactDetails(contact.id)"
                            variant="primary"
                            class="ml-auto"
                            >Visa</b-button
                          >
                        </b-col>
                      </b-row>
                    </div>
                  </b-card>
                </template>
                <template v-else></template>
              </div>
            </div>
          </b-collapse>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BCard,
  BButton,
  BCollapse,
  BAvatar,
} from "bootstrap-vue";
import { FeatherIcon } from "vue-feather-icons";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "ContactList",
  components: {
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BCard,
    BButton,
    BCollapse,
    BAvatar,
    FeatherIcon,
  },
  props: {
    mode: String,
  },
  data() {
    return {
      searchQuery: "",
      contactImageUrls: [],
    };
  },

  async mounted() {
    for (let i = 0; i < this.contacts.length; i++) {
      if (this.contacts[i].avatar) {
        this.$set(
          this.contactImageUrls,
          this.contacts[i].id,
          await this.fetchImageWithToken(this.contacts[i].avatar.medium)
        );
      }
    }
  },
  computed: {
    ...mapGetters({ contacts: "getContacts" }),
    accessGroups() {
      return this.getFilteredAccessGroups();
    },
    filteredContacts() {
      return this.contacts.filter((contact) => {
        if (!contact.first_name) return;

        return (
          contact.first_name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
          contact.last_name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
          contact.organisation
            ?.toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
          contact.title?.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      });
    },
  },
  methods: {
    goToContactDetails(contactId) {
      this.$router.push({
        name: "contact-details",
        params: { title: "", id: contactId },
      });
    },
    async fetchImageWithToken(imageUrl) {
      try {
        const token = JSON.parse(localStorage.getItem("user")).jwt;

        const response = await axios.get(imageUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });

        // use the set $ to upade the imageUrls
        return URL.createObjectURL(response.data);
      } catch (error) {
        return "";
      }
    },
    getFilteredAccessGroups() {
      if (!this.contacts) return;

      let filtered = [];
      for (let i = 0; i < this.contacts.length; i++) {
        for (let j = 0; j < this.contacts[i].access_groups.length; j++) {
          if (
            this.mode == "Viktigt" &&
            this.contacts[i].access_groups[j].title != "Viktig person"
          )
            continue;
          if (
            filtered.find((a) => a.id == this.contacts[i].access_groups[j].id)
          )
            continue;
          filtered.push(this.contacts[i].access_groups[j]);
        }
      }

      filtered.sort((a, b) => a.sort_order - b.sort_order);
      return filtered;
    },
  },
};
</script>

<style scoped>
.contact-group > .btn {
  text-align: left;
  padding-left: 0;
  /* border: 0!important;
        background-color: #fff;
        box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%); */
}
.contact-group > .btn span {
  float: right;
}
.btn svg {
  transition: all 0.25s ease-in-out;
}
.btn.collapsed svg {
  transform: rotate(180deg);
}
.btn.not-collapsed svg {
  transform: rotate(0deg);
}
.card {
  margin-bottom: 1rem;
}
.ce-contact-info {
  display: flex;
  align-items: center;
}
.ce-contact-avatar {
  padding-right: 1rem;
}
.ce-contact-actions {
  display: flex;
  align-items: center;
}

.tag-style {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  color: white;

  border-radius: 22px;
  background: #7468f0;
}
</style>
